import { useEffect } from 'react';
import { environment } from '../environment';
import { useIsDesktop } from './use-is-desktop';

export function useHideIntercom(): void {
  useEffect(() => {
    if (environment.INTERCOM_APP_ID === 'false') {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const intercom = (window as any).Intercom;

    intercom('update', {
      hide_default_launcher: true
    });

    return (): void => {
      intercom('update', {
        hide_default_launcher: false
      });
    };
  }, []);
}

export function useMobileIntercom(intercomBooted: boolean): void {
  const isDesktop = useIsDesktop();

  useEffect((): void | (() => void) => {
    if (environment.INTERCOM_APP_ID === 'false') {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const intercom = (window as any).Intercom;

    if (!isDesktop && intercom && intercomBooted) {
      intercom('update', {
        vertical_padding: 70
      });

      return (): void => {
        intercom('update', {
          vertical_padding: 20
        });
      };
    }
  }, [intercomBooted, isDesktop]);
}
